import { AppState } from 'types/app';

export const selectFeature = (feature: string, state: AppState) => state.features?.[feature];
